import React from "react";

export const CrossIcon = () => {
    return <svg className="w-8 h-8 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="-10 -10 80 80">
        <rect x="0" y="0" width="60" height="60" rx="40" ry="40" fill="#FFD9C8"></rect>
        <path fill="#E26D37" stroke="#E26D37" strokeWidth="1" fillRule="evenodd" d="M9.707 10l4.147-4.146a.5.5 0 0 0-.708-.708L9 9.293l-4.146-4.147a.5.5 0 0 0-.708.708L8.293 10l-4.147 4.146a.5.5 0 0 0 .708.708L9 10.707l4.146 4.147a.5.5 0 0 0 .708-.708L9.707 10z" clipRule="evenodd" transform="translate(8, 8) scale(2.25)" />
    </svg>
}